// @theme component
import { useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { useDTAG } from '@theme/js/hooks/useDTAG';
import { getScript } from '@core/js/utils/scripts.util';
import { IPragmaticMessageData } from '@theme/js/components/main/GamesGrid/components/Game/components/PragmaticPlay/store/types';
import { setPragmaticTableData } from '@theme/js/components/main/GamesGrid/components/Game/components/PragmaticPlay/store/actions';

export const usePragmaticAPI = () => {
    const pragmaticUrl = useDTAG('PRAGMATIC_URL');
    const dispatch = useDispatch();

    const fetchPragmaticAPI = useCallback(async () => {
        await getScript(`https://${pragmaticUrl}/dgaAPI.js`)
            .catch((e) => console.error(e));

        window.dga.connect(pragmaticUrl);
        window.dga.onMessage = function(message: IPragmaticMessageData) {
            if (message?.tableOpen && message?.tableId && message?.gameResult) {
                dispatch(setPragmaticTableData(message));
            }
        };
    }, [pragmaticUrl, dispatch]);

    useEffect(() => {
        if (!pragmaticUrl) {
            return;
        }

        fetchPragmaticAPI();

        return () => {
            window.dga.disconnect();
        };
    }, [fetchPragmaticAPI, pragmaticUrl]);
};
